module.exports = __webpack_public_path__ + "img/foot-left.62761474.jpg";